<template>
    <vs-table 
        :data="data"
        :max-items="itemsPerPage"
        pagination
        :stripe="true"
        search
    >
        <template slot="header">
            <!-- ITEMS PER PAGE -->
            <div class="flex-grow">
                <vs-dropdown vs-trigger-click class="cursor-pointer">
                    <div class="p-3 border border-solid d-theme-border-grey-light rounded-full cursor-pointer flex items-center justify-between font-medium">
                        <span class="mr-2">
                            {{ itemsPerPage }}
                        </span>
                        <feather-icon
                            icon="ChevronDownIcon"
                            svgClasses="h-4 w-4"
                        />
                    </div>
                    <vs-dropdown-menu>
                        <vs-dropdown-item :key="ipp" v-for="ipp in [100, 200, 300]" @click="itemsPerPage = ipp"><span>{{ipp}}</span></vs-dropdown-item>
                    </vs-dropdown-menu>
                </vs-dropdown> 
                <vx-button class="mr-5" color="primary" type="border" :active="date == 'this_week'" :to="{ path: '/duplication', query: { date: 'this_week' }  }">Tuần này</vx-button>
                <vx-button class="mr-5" color="success" type="border" :active="date == 'last_week'" :to="{ path: '/duplication', query: { date: 'last_week' } }">Tuần trước</vx-button>
            </div>
        </template>
        <template slot="thead">
            <vs-th
                :key="idx"
                v-for="(h,idx) in header"
                :sort-key="h.field"
            >
                {{ h.title }}
            </vs-th>
            <vs-th>Actions</vs-th>
        </template>
        <template slot-scope="{ data }">
            <vs-tr :key="data[indextr].member_key+'_'+data[indextr].cheat_id+'_'+indextr" v-for="(tr, indextr) in data">
                <vs-td :key="idx" v-for="(h,idx) in header" :data="data[indextr][h.field]">
                    <template v-if="h.field == 'member_key'">
                        <vs-button color="dark" 
                            type="flat" 
                            class="vs-button--link"
                            target
                            :href="{ url: '/cheats/detail?member_name='+data[indextr].member_key+
                                                            '&cheat_id='+data[indextr].cheat_id+
                                                            '&from='+data[indextr].start_date+
                                                            '&to='+data[indextr].end_date
                                }"
                            >{{ data[indextr][h.field].toUpperCase() }}</vs-button>
                    </template>
                    <template v-else-if="h.render">
                        {{ h.render(data[indextr][h.field]) }}
                    </template>
                    <template v-else>
                        {{ data[indextr][h.field] }}
                    </template>
                </vs-td>
                <vs-td>
                    <vs-button v-if="$acl.check('fetchMemberReadPermission')" @click="read(data[indextr])" class="read-btn" size="small" color="rgb(134, 4, 98)" type="filled">Đã xem</vs-button>
                </vs-td>
            </vs-tr>
        </template>
    </vs-table>
</template>

<script>
import { mapGetters } from 'vuex';
import Swal from 'sweetalert2';
import vSelect from 'vue-select';
import { AclRule } from 'vue-acl';

export default {
    props: ["date", "data"],
    data(){
        return {
            itemsPerPage: 200,
            currentPage: 1,
            header: [],
        }
    },
    components: {
        vSelect,
    },
    computed:{
        ...mapGetters([
            'currentUser'
        ]),
        fetchDupPermission(){
            return new AclRule('store_member_dup_full_user').generate();
        },
        fetchMemberReadPermission(){
            return new AclRule('store_member_read').generate();
        },
    },
    methods:{
        read(member){
            let vm = this;
            let payload = {
                "member_name": member.member_key,
                "cheat_id": member.cheat_id
            };

            vm.$http.post("member_read", payload).then((res) => {
                vm.$emit("changeRead", res.data.data.member_name);
            });
        }
    },
    created(){
        if(this.$acl.check('fetchDupPermission')){
            this.header = [
                    { title:"Thành viên", field:"member_key", render: function(val){  return val.toUpperCase(); }}, 

                    { title:"User", field:"user_info", render: function(val){  return val; } },

                    { title:"Kiểu", field:"cheat" }, 
                    { title:"Thành viên so sánh", field:"member_value" }, 
                    { title:"Bet max", field:"bet_max" }, 
                    { title:"Bet min", field:"bet_min" }, 
                    { title:"Tổng cược", field:"bet_total" }, 
                    { title:"Từ ngày", field:"start_date" }, 
                    { title:"Đến ngày", field:"end_date" }
                ];
        }else{
            this.header = [
                    { title:"Thành viên", field:"member_key", render: function(val){  return val.toUpperCase(); }}, 
                    { title:"Kiểu", field:"cheat" }, 
                    { title:"Thành viên so sánh", field:"member_value" }, 
                    { title:"Bet max", field:"bet_max" }, 
                    { title:"Bet min", field:"bet_min" }, 
                    { title:"Tổng cược", field:"bet_total" }, 
                    { title:"Từ ngày", field:"start_date" }, 
                    { title:"Đến ngày", field:"end_date" }
                ];
        }
    }
};
</script>

<style>
.swal2-container{
    z-index: 99999;
}
.read-btn{
    padding: 5px !important;
}
</style>
